import React, { useState, useEffect, useRef } from 'react';
import { Table, Popover, Checkbox } from 'antd';
import styled from 'styled-components';
import * as _ from 'lodash'

const UserGroups = ({userIds, groupData, onGroupChanged, userForm, onPageChange}) => {

  const [loading, setLoading] = useState(true)
  const [pagination, setPagination] = useState({total: 0, defaultPageSize: 50, defaultCurrent: 1});

  useEffect(() => {
    setLoading(true);
    setPagination(p => ({...p, current: 1}))
  }, [userIds])

  useEffect(() => {
    if(groupData.data?.length > 0) {
      setLoading(false); 
      setPagination(p => ({...p, total: groupData._meta?.totalRecords}));
    }
  }, [groupData])

  const onCheckboxClick = (e, groupName) => {
    onGroupChanged({ groupId: groupName, member: e.target.checked });
  }

  const columns = [
    {
      title: 'Group Name',
      dataIndex: 'groupId'
    },
    {
      title: 'Included',
      dataIndex: 'member',
      align: 'center',
      render: (text, record) => {
        if(record.singleUser && !record.member && record.singleUserAssigned || userIds.length > 1 && record.singleUser) {

          const contentElement = userIds.length > 1 && !record.singleUserAssigned ? 
              <>There is currently no user assigned to this group. You are not able to modify this group when multiple users are selected.</> :
              <>Current user assigned to this group: <b>{record.singleUserAssigned}</b></>;

          return (
            <Popover
              title="This is a single user group"
              content={
                <div style={{width: '225px', overflowWrap: 'break-word'}}>
                  {contentElement}
                </div>
              }
            >
              <Checkbox
                disabled={true}
                onChange={(e) => onCheckboxClick(e, record.groupId)}
              />
            </Popover>
          )
        }
        else {
          return (
            <Checkbox
              defaultChecked={record.member}
              onChange={(e) => onCheckboxClick(e, record.groupId)}
            />
          )
        }
      },
    }
  ];

  const handleTableChange = (pagination, filters, sorter) => {

    const pager = { ...pagination };
    pager.current = pagination.current;
    setPagination(pager);

    const cf = {
      limit: pagination.defaultPageSize,
      skip: (pagination.current - 1) * pagination.defaultPageSize,
    }

    onPageChange(cf);
  };

  return (
    <GroupsContainer offset={userForm.current.offsetHeight}>
      {groupData.data?.length > 0 && userForm.current &&
          <Table
            size="small"
            columns={columns}
            rowKey={record => record.groupId}
            loading={loading}
            dataSource={groupData.data}
            pagination={pagination}
            hideOnSinglePage={true}
            onChange={handleTableChange}
            scroll={{ y: `calc(100vh - 650px - ${userForm.current.offsetHeight}px)` }}
          />
      }
    </GroupsContainer>
  );
}

const GroupsContainer = styled.div`
  overflow: hidden;
  .ant-table-body {
    min-height: ${p => `max(calc(100vh - 650px - ${p.offset}px), 200px)`};
  }
  .ant-pagination {
    float: left;
  }
`

export default UserGroups;